import {MEDIA_CATEGORIES} from "@/app/utils/MediaLinks";

export default function(code, options) {
    if (code) {
        var name = MEDIA_CATEGORIES[code];
        if (!name) name = code;
        return new Handlebars.SafeString(name);
    }
    return new Handlebars.SafeString("Unknown");
}